var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"srcset":require("../../assets/bgreg.webp"),"type":"image/webp"}}),_c('source',{attrs:{"srcset":require("../../assets/bgreg.png"),"type":"image/png"}}),_c('img',{staticClass:"h-screen object-cover pointer-events-none select-none w-full",attrs:{"src":require("../../assets/bgreg.png"),"alt":"Background Travel"}})])
}]

export { render, staticRenderFns }